import React, { useState } from 'react'

import { DisableTwoFactorDeviceContainerProps } from '../ChangeTwoFactorDevice/ChangeTwoFactorDevice.types'

import { DisableTwoFactorDevice } from './DisableTwoFactorDevice'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'
import { useMutation } from '@percent/cause-dashboard/common/hooks'

export function DisableTwoFactorDeviceContainer({
  isOpened,
  onClose,
  setChecked
}: DisableTwoFactorDeviceContainerProps) {
  const { authService } = useServices()

  const [showCompleted, setShowCompleted] = useState(false)

  const [{ isLoading, errorMessage }, { apiFunc: disableFunc }] = useMutation(authService.disable2fa, () => {
    setChecked(false)
    setShowCompleted(true)
  })

  return (
    <DisableTwoFactorDevice
      disableFunc={disableFunc}
      errorMessage={errorMessage}
      isOpened={isOpened}
      isLoading={isLoading}
      onClose={onClose}
      showCompleted={showCompleted}
    />
  )
}
